__webpack_require__.p = "https://media.dndbeyond.com/character-app/";